(function(window, document) {
  'use strict';

  function updateVariantPrices(container) {
    container = container || document;

    var wrappers = container === document
      ? document.querySelectorAll('.custom-product-price-wrapper')
      : container instanceof Element && container.matches('.custom-product-price-wrapper')
        ? [container]
        : container.querySelectorAll('.custom-product-price-wrapper');

    wrappers.forEach(function(wrapper) {
      try {
        var variantSpans = wrapper.querySelectorAll('span[data-variant-id]');
        if (!variantSpans.length) return;

        // Get variant ID from URL ?variant= or default to first span
        var link = wrapper.closest('a.product-link');
        var variantId = null;
        if (link && link.href) {
          var m = link.href.match(/[?&]variant=(\d+)/);
          variantId = m ? m[1] : null;
        }
        if (!variantId) variantId = variantSpans[0].dataset.variantId;

        var rrpSpan = wrapper.querySelector('span[data-variant-id="' + variantId + '"]');
        var rrpDisplay = wrapper.querySelector('.custom-rrp-display');
        if (!rrpDisplay || !rrpSpan) return;

        var raw = rrpSpan.dataset.rrp;
        var rrp = parseFloat(raw);
        rrpDisplay.textContent = isNaN(rrp) ? '' : 'RRP: £' + rrp.toFixed(2);

      } catch (err) {
        if (window.console) console.error('updateVariantPrices error', err);
      }
    });
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', function() {
    updateVariantPrices();

    // Observe for dynamic additions
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) updateVariantPrices(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.updateVariantPrices = updateVariantPrices;

})(window, document);
